import type { IconSvgObject } from './types';

const PinLocation02Icon: IconSvgObject = [
  ["path", { d: "M17 18C17 19.6569 14.7614 21 12 21C9.23858 21 7 19.6569 7 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 11V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "7", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PinLocation02Icon;
